import { render, staticRenderFns } from "./CompanyTagCard.vue?vue&type=template&id=517f3746"
import script from "./CompanyTagCard.vue?vue&type=script&lang=js"
export * from "./CompanyTagCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports